import { message } from 'antd'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import roleManager from '../Components/roles'
import { errorMessage } from '../helpers'
import { utility } from '../helpers/loader'
import { setIsValueSet } from '../redux/features/utils.slice'

const EmployeeCheck = ({ children, pageName }) => {

    let history = useHistory()
    let { isValueSet } = useSelector(state => state.utils)


    useEffect(() => {
        if (isValueSet) {
            history?.push("/Locomotive-work-order-edit", { id: localStorage.getItem("loco-wo-id") })
            utility?.dispatch(setIsValueSet(false))
        }
    }, [isValueSet])

    if (roleManager("sidebar", pageName)) {
        localStorage.setItem("pageMode", "edit")
        return <>{children}</>
    }
    else if (pageName === 'locomotive' && !roleManager("sidebar", 'locomotive') && history?.location?.pathname === '/Locomotive-work-order-edit') {
        localStorage.setItem("pageMode", "view-only")
        return <>{children}</>
    }
    else if (pageName =='pending_payroll_Ticket' && roleManager("sidebar", 'pending_payroll') && history?.location?.pathname == '/pending-payroll-tickets') {
        localStorage.setItem("pageMode", "edit")
        return <>{children}</>
    }
    else {
        history.push('/dashboard')
        message.error("Access denied")
        return <></>
    }

}

export default EmployeeCheck